<template>
  <div class="share-landing-page">
    <div v-loading="loading" class="share-content" v-if="pageData">
      <!-- 商品主图 -->
      <div class="product-gallery">
        <img :src="pageData.productImage" class="main-image" v-if="pageData.productImage" />
      </div>

      <!-- 商品信息 -->
      <div class="product-info">
        <div class="product-name">{{ pageData.productName }}</div>
        <div class="product-desc">{{ pageData.productDescription }}</div>
        <div class="price-row">
          <span class="share-price">¥{{ pageData.priceAtShare }}</span>
          <span class="original-price" v-if="pageData.originalPrice">¥{{ pageData.originalPrice }}</span>
          <span class="discount-tag" v-if="pageData.priceAtShare && pageData.originalPrice">
            {{ Math.round(pageData.priceAtShare / pageData.originalPrice * 10) }}折
          </span>
        </div>
      </div>

      <!-- 档口名片 -->
      <div class="stall-card">
        <div class="stall-avatar">🏪</div>
        <div class="stall-info">
          <div class="stall-name">{{ pageData.stallName || '档口' }}</div>
          <div class="stall-contact" v-if="pageData.stallContact">联系人：{{ pageData.stallContact }}</div>
          <div class="stall-phone" v-if="pageData.stallPhone">📞 {{ pageData.stallPhone }}</div>
        </div>
      </div>

      <!-- 行动按钮 -->
      <div class="action-section">
        <template v-if="!pageData.isLoggedIn">
          <el-button type="primary" size="large" @click="goToRegister" class="cta-btn">
            立即注册下单
          </el-button>
          <p class="hint-text">注册后享特价优惠</p>
        </template>
        <template v-else>
          <template v-if="pageData.hasOrdered">
            <el-button type="primary" size="large" @click="goToProducts" class="cta-btn">
              立即预订
            </el-button>
          </template>
          <template v-else>
            <el-button type="success" size="large" @click="goToProducts" class="cta-btn">
              去下单
            </el-button>
            <p class="hint-text">完成首单享更多优惠</p>
          </template>
        </template>
      </div>
    </div>

    <!-- 无效分享 -->
    <div class="invalid-share" v-else-if="!loading">
      <el-empty description="分享链接已失效" />
      <el-button type="primary" @click="$router.push('/')">返回首页</el-button>
    </div>
  </div>
</template>

<script>
import shareApi from '@/services/share';

export default {
  name: 'ShareLanding',
  data() {
    return {
      pageData: null,
      loading: true
    };
  },
  created() {
    this.loadShareData();
  },
  methods: {
    async loadShareData() {
      const shareCode = this.$route.params.shareCode;
      const stallId = this.$route.query.stallId;

      try {
        this.pageData = await shareApi.getSharePage(shareCode, stallId);
      } catch (error) {
        console.error('加载分享数据失败:', error);
        this.pageData = null;
      } finally {
        this.loading = false;
      }
    },

    goToRegister() {
      this.$router.push({
        path: '/register',
        query: {
          shareCode: this.$route.params.shareCode,
          stallId: this.$route.query.stallId
        }
      });
    },

    goToProducts() {
      this.$router.push('/stall/products');
    }
  }
};
</script>

<style scoped>
.share-landing-page {
  max-width: 480px;
  margin: 0 auto;
  background: #fff;
  min-height: 100vh;
}

.product-gallery {
  width: 100%;
  background: #f5f5f5;
}

.main-image {
  width: 100%;
  height: 300px;
  object-fit: cover;
}

.product-info {
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.product-name {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
}

.product-desc {
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
  line-height: 1.5;
}

.price-row {
  display: flex;
  align-items: baseline;
  gap: 10px;
}

.share-price {
  font-size: 28px;
  font-weight: bold;
  color: #e74c3c;
}

.original-price {
  font-size: 14px;
  color: #999;
  text-decoration: line-through;
}

.discount-tag {
  background: #ffe8e8;
  color: #e74c3c;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
}

.stall-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: #f8f8f8;
  margin: 12px;
  border-radius: 10px;
}

.stall-avatar {
  font-size: 36px;
}

.stall-info {
  flex: 1;
}

.stall-name {
  font-size: 15px;
  font-weight: 500;
  color: #333;
}

.stall-contact,
.stall-phone {
  font-size: 13px;
  color: #666;
  margin-top: 2px;
}

.action-section {
  padding: 20px 16px;
  text-align: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  box-shadow: 0 -2px 10px rgba(0,0,0,0.05);
  max-width: 480px;
  margin: 0 auto;
}

.cta-btn {
  width: 100%;
  height: 48px;
  font-size: 16px;
  border-radius: 24px;
}

.hint-text {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
  margin-bottom: 0;
}

.invalid-share {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 40px;
}
</style>
